export default __webpack_public_path__ + "static/media/detail_big_12_5.0e87685d.jpg";